export default {
  children: [
    {
      path: 'campaignId',
      name: 'campaignDetails',
      component: () => import('@/campaigns/pages/details/CampaignDetailsPage.vue'),
      meta: {
        pageTitle: ' Campaign Details',
        requiresAuth: true,
        hideSearchFromHeader: false,
        showRightPanel: false,
      },
    },
    {
      path: 'results',
      name: 'campaignResults',
      component: () => import('@/campaigns/pages/results/CampaignResultsPage.vue'),
      meta: {
        pageTitle: 'Campaign Awards',
        requiresAuth: true,
        hideSearchFromHeader: false,
        showRightPanel: false,
      },
    },
  ],
};
